export default "__VITE_ASSET__CEp5CUj2__"